import helpers from '../helpers';

const init = () => {
	const btns = document.querySelectorAll('.js-show-more');

	if (!btns.length) {
		return false;
	}

	btns.forEach((el) => {
		el.addEventListener('click', function () {
			const id = this.dataset.more;
			const target = document.getElementById(id);

			if (!target) {
				return false;
			}

			target.classList.toggle('is-active');

			helpers.toggleText(this, 'Свернуть', 'Ещё');

			if ($(this).closest('#material').length) {
				$(this).closest('#material').find('.js-show-more').toggleClass('is-opened');
			} else {
				this.classList.toggle('is-opened');
			}

			return true;
		});
	});

	return true;
};

export default {
	init,
};
